<div class="container-fluid page-container">
  <div class="row g-3">

    <!-- LEFT PROFILE PANEL -->
    <div class="col-md-4">
      <div class="profile-card shadow-sm">

        <div class="profile-header">
          <img
            [src]="userData.image"
            (error)="onImageError($event)"
            class="profile-image"
          />

          <h5 class="profile-name">{{ userData.user_name }}</h5>
          <p class="profile-contact">{{ userData.phone_num }}</p>
          <p class="profile-contact">{{ userData.email_id }}</p>
        </div>

        <div class="profile-info-grid">

          <div class="info-item">
            <label>Father's Name</label>
            <span>{{ userData.father_name }}</span>
          </div>

          <div class="info-item">
            <label>First Graduate</label>
            <span>{{ userData.first_graduate }}</span>
          </div>

          <div class="info-item">
            <label>Community</label>
            <span>{{ userData.community }}</span>
          </div>

          <div class="info-item">
            <label>Date of Birth</label>
            <span>{{ userData.dateOfBirth }}</span>
          </div>

          <div class="info-item">
            <label>Place</label>
            <span>{{ userData.place }}</span>
          </div>

          <div class="info-item">
            <label>District</label>
            <span>{{ userData.district }}</span>
          </div>

          <div class="info-item">
            <label>Educational Qualification</label>
            <span>{{ userData.educational_qualification }}</span>
          </div>

          <div class="info-item">
            <label>Institution Name</label>
            <span>{{ userData.institution_name }}</span>
          </div>

          <div class="info-item">
            <label>Preferred Courses</label>
            <span>{{ userData.prefered_course }}</span>
          </div>

          <div class="info-item">
            <label>Referral Code</label>
            <span>{{ userData.referal_code }}</span>
          </div>

          <div class="info-item">
            <label>Referred Code</label>
            <span>{{ userData.referred_code }}</span>
          </div>

        </div>
      </div>
    </div>

    <!-- RIGHT MAIN CONTENT -->
    <div class="col-md-8">

      <!-- ADMISSION FORMS GRID -->
      <div class="section-card shadow-sm">
        <h5 class="section-title">Admission Forms</h5>

        <div *ngIf="admissionform.length > 0; else noAdmission" class="grid-container">

          <div class="grid-card" *ngFor="let a of limitedAdmissionForms">

            <img [src]="a.image" class="grid-card-image" (error)="onImageError($event)" />

            <h6 class="grid-card-title">{{ a.collegename }}</h6>
            <p class="grid-card-subtitle">{{ a.district }}</p>

            <button class="btn btn-sm btn-primary" (click)="downloadForm(a)">
              Download
            </button>

          </div>
        </div>

        <!-- SHOW MORE / LESS -->
        <div class="text-center mt-2" *ngIf="admissionform.length > admissionLimit">
          <button class="btn btn-outline-secondary btn-sm" (click)="toggleAdmissionView()">
            {{ showAllAdmissions ? "Show Less" : "Show More" }}
          </button>
        </div>

        <ng-template #noAdmission>
          <p class="empty-text">No Admission Forms</p>
        </ng-template>
      </div>

      <!-- INVOICES GRID -->
      <div class="section-card shadow-sm mt-3">
        <h5 class="section-title">Invoices</h5>

        <div *ngIf="paymentDetails.length > 0; else noInvoices" class="grid-container">

          <div class="invoice-card" *ngFor="let p of limitedInvoices">

            <h6 class="grid-card-title">{{ p.collage_name || p.college_name }}</h6>

            <p class="grid-card-subtitle">
              Amount Paid: {{ p.total_amount_paid | currency:'INR' }}
            </p>

            <small class="text-muted">{{ p.paid_date }}</small>

            <button
              class="btn btn-sm btn-primary mt-2"
              *ngIf="p.receipt_id"
              (click)="downloadInvoice(p)"
            >
              Invoice
            </button>

          </div>
        </div>

        <!-- SHOW MORE / LESS -->
        <div class="text-center mt-2" *ngIf="paymentDetails.length > invoiceLimit">
          <button class="btn btn-outline-secondary btn-sm" (click)="toggleInvoiceView()">
            {{ showAllInvoices ? "Show Less" : "Show More" }}
          </button>
        </div>

        <ng-template #noInvoices>
          <p class="empty-text">No Invoices</p>
        </ng-template>

      </div>

    </div>
  </div>
</div>
